import { InsurerFormValues } from '@/core/domain/people/Insurers/Insurers.types';
import { removeMask } from '@/utils/mask';

type Callback = (values: InsurerFormValues) => Promise<unknown>;

export default async function handlerGeneralUpdate(
  values: InsurerFormValues,
  active: boolean,
  callback: Callback,
) {
  const obj: InsurerFormValues = {
    ...values,
    cnpj: removeMask(values.cnpj),
    active,
  };

  await callback(obj);
}
